/*
*  Copyright (c) 2023, Filespin
*  All rights reserved.
*
**/

import styles from './style.module.scss';
import BaseModal from 'src/components/BaseModal';
import Paper from 'src/components/Paper';
import Input from 'src/components/Input';
import Textarea from 'src/components/Textarea';
import Button from 'src/components/Button';
import useComponentHooks  from './hooks';
import ConfirmSubtitlesWordSubstitutionModalProps from './types';
import generateHandlers from './handlers';

import * as React from 'react';


/**
 * ConfirmSubtitlesWordSubstitutionModal
 * 
 * @param props
 * @returns
 * 
 * @example
 * 
 * <ConfirmSubtitlesWordSubstitutionModal
 *   type="add"
 *   variants={['']}
 *   word=""
 * />
 * 
 **/
export const ConfirmSubtitlesWordSubstitutionModal: React.FC<ConfirmSubtitlesWordSubstitutionModalProps> = (props) => {

  const hooks = useComponentHooks(props.word, props.variants);
  const handlers = generateHandlers(props, hooks);

  return (
    <BaseModal>
      <h3>{props.title}</h3>
      <Paper>
        <Input
          label="Word"
          value={hooks.form.form.word}
          onChange={handlers.changeValueOfWord}
          error={hooks.form.formErrors.word}
          variant="secondary"
          placeholder="Word..."
        />
        <Textarea
          className={styles.formGroup}
          label="Variants"
          value={hooks.form.form.variants}
          onChange={(value) => hooks.form.handleChange('variants', value)}
          error={hooks.form.formErrors.variants}
          placeholder="Word Variants(comma seperated)..."
        />
      </Paper>
      <div className={styles.modalActions}>
        <Button size="small" mode="tertiary" onClick={hooks.modal.closeModal}>
          Cancel
        </Button>
        <Button size="small" onClick={handlers.handleSubmit}>
          {props.type === 'edit' ? 'Update Word' : 'Add word'}
        </Button>
      </div>
    </BaseModal>
  );
};

export default ConfirmSubtitlesWordSubstitutionModal;
